import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: "en",
  },
  getters: {
    language: (state) => state.language,
  },
  mutations: {
    SET_LANGUAGE(state, language) {
      state.language = language;
    },
  },
  actions: {
    initLanguage({ commit }) {
      // Default rule:
      // 1. If persisted, use it (handled by vuex-persistedstate automatically if configured, 
      //    but since we are adding it now, it might be empty on first load)
      // 2. If browser is Korean, use 'ko'
      // 3. Otherwise 'en'

      // Note: vuex-persistedstate rehydrates state before this action if plugin is setup correctly.
      // We need to check if state is already set by persistence.
      // But we can just run this logic on App mount if state is default.

      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang.toLowerCase().includes("ko")) {
        commit("SET_LANGUAGE", "ko");
      } else {
        commit("SET_LANGUAGE", "en");
      }
    },
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    }
  },
  modules: {},
  plugins: [
    createPersistedState({
      paths: ["language"],
    }),
  ],
});
